/*
 * @Description:产品主数据
 * @Author: miaomiao
 * @Date: 2021-01-13 15:18:54
 * @LastEditTime: 2021-06-12 17:48:08
 * @LastEditors: JikeyChang
 */
import db from '@/api/db';

/**
 * [model 产品主数据]
 * @type {Object}
 */
const model = {
  /**
   * 获取部门信息
   * @param {*} param
   */
  getDeptTree(param) {
    return db.get('/umd/dept/listDeptVO', param);
  },
  /**
   * 获取产品线列表
   * @param {*} param
   */
  getProLineList(param) {
    return db.post('/pmd/productLine/list', param);
  },
  /* 新增产品线 */
  addProLine(param) {
    return db.post('/pmd/productLine/create', param);
  },
  /* 产品线排序 */
  updateProLine(param) {
    return db.post('/pmd/productLine/updateBatch', param);
  },
  /* 修改产品线 */
  editProLine(param) {
    return db.post('/pmd/productLine/modify', param);
  },
  /* 获取单条产品线信息 */
  getOneProLine(param) {
    return db.get('/pmd/productLine/getVO', param);
  },
  /* 获取单条产品线树形结构信息 */
  getProLineTree(param) {
    return db.post('/pmd/productLine/tree', param);
  },
  /* 新增子产品线 */
  addProChildLine(param) {
    return db.post('/pmd/productLineChild/create', param);
  },
  /* 修改子产品线 */
  editProChildLine(param) {
    return db.post('/pmd/productLineChild/modify', param);
  },
  /* 获取单条子产品线信息 */
  getOneProChildLine(param) {
    return db.get('/pmd/productLineChild/getVO', param);
  },
  /* 获取单条产品信息 */
  getOneProMsg(param) {
    if (param.type === '产品') {
      return db.get('/pmd/product/getVO', param);
    }
    return db.get('/pmd/project/getVO', param);
  },
  /* 获取单条项目信息 */
  getOneProjectMsg(param) {
    return db.get('/pmd/project/getVO', param);
  },
  /* 修改产品信息 */
  editProduct(param) {
    return db.post('/pmd/product/modify', param);
  },
  /* 数据字典 */
  getDictList(param) {
    return db.post('/sys/dictionary/list', param);
  },
  // 输入名字 自动联想
  listByNameLike(param) {
    const sendParam = {
      name: param.keyword,
    };
    return db.get('/umd/user/listUser', sendParam);
  },
  // 部门列表
  getDepList(param) {
    return db.get('/umd/dept/getDeptList', param);
  },
  // 产品线导出
  proLineExport(param) {
    return db.post('/pmd/productLine/exportExcel', param, { responseType: 'blob' });
  },
};

export default model;
